import React from "react";
import { formatPrice } from "../../lib/api";
import { formatDate } from "./utils";

const OrdersTab = ({ orders }) => (
  <div className="bg-white border border-line overflow-x-auto" data-testid="admin-orders-panel">
    <table className="w-full text-sm min-w-[800px]">
      <thead className="border-b border-line">
        <tr className="text-left">
          <th className="px-4 py-3 overline">Session</th>
          <th className="px-4 py-3 overline">Amount</th>
          <th className="px-4 py-3 overline">Status</th>
          <th className="px-4 py-3 overline">Items</th>
          <th className="px-4 py-3 overline">Created</th>
        </tr>
      </thead>
      <tbody>
        {orders.length === 0 ? (
          <tr>
            <td colSpan="5" className="px-4 py-8 text-mute text-center">
              No orders yet.
            </td>
          </tr>
        ) : (
          orders.map((o) => (
            <tr key={o.session_id} className="border-b border-line">
              <td className="px-4 py-3 mono text-xs truncate max-w-[200px]">{o.session_id}</td>
              <td className="px-4 py-3 mono">{formatPrice(o.amount, o.currency || "GBP")}</td>
              <td className="px-4 py-3">
                <span
                  className={`mono text-[10px] tracking-widest uppercase px-2 py-1 border ${
                    o.payment_status === "paid"
                      ? "bg-pritch-volt-trim border-pritch-volt-trim text-ink"
                      : "border-line text-mute"
                  }`}
                >
                  {o.payment_status || o.status}
                </span>
              </td>
              <td className="px-4 py-3 text-xs">{(o.items || []).length}</td>
              <td className="px-4 py-3 mono text-xs text-mute">{formatDate(o.created_at)}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
);

export default OrdersTab;
